<template>
	<v-layout row wrap>
		<v-flex xs8 pr-1>
			<DatePicker :readonly="readonly" :dateLabel="dateLabel" :error="$props.error" v-model="selectedValue.date"/>
		</v-flex>
		<v-flex xs4 pl-1>
			<v-layout row wrap>
				<v-flex xs12 ma-2>
					<v-text-field

							:readonly="readonly"
							:label="timeLabel"
							:rules="[rules.time]"
							:mask="'##:##:##'"
							:error="$props.error != ''"
							return-masked-value
							v-model="selectedValue.time"
					></v-text-field>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	import DatePicker from "./DatePicker";

	export default {
		name: "DateTimePicker",
		components: {DatePicker},
		props: ['readonly', 'value', 'dateLabel', 'timeLabel', 'error'],
		data() {
			return {
				selectedValue: {
					date: null,
					time: null
				},
				rules: {
					time: value => {
						return this.$timePattern.test(value) || 'hh:mm:ss'
					}
				}
			}
		},
		watch: {
			value: function (newVal, oldVal) {
				if (newVal != oldVal) {
					this.setValue(newVal);
				}
			},
			selectedValue: {
				handler: function () {
					let newValue = null;
					if ((this.selectedValue.date != null) && (this.selectedValue.time != null)) {
						newValue = this.selectedValue.date + ' ' + this.selectedValue.time;
					}
					if (newValue != null) {
						if (newValue != this.$props.value) {
							this.$nextTick(() => {
								this.$emit('input', newValue);
							})
						}
					} else {
						this.$nextTick(() => {
							this.$emit('input', null);
						})
					}
				},
				deep: true
			}
		},
		methods: {
			setValue(newVal) {
				if (newVal != null) {
					const [date, time] = newVal.split(' ');
					this.selectedValue.date = date;
					this.selectedValue.time = time;
				} else {
					this.selectedValue.date = null;
					this.selectedValue.time = null;
				}
			}
		},
		mounted() {
			this.setValue(this.$props.value);
		}
	}
</script>

<style scoped>

</style>
